import { Error } from "@/types/error.definition";
import { Specialty } from "@/types/specialty.definition";
import { call, put, takeLatest } from "redux-saga/effects";
import { specialtyApi } from "../../services/specialties.api";
import {
  getSpecialtiesFailure,
  getSpecialtiesRequest,
  getSpecialtiesSuccess,
} from "../reducers/specialtiesSlice";

function* getSpecialtiesSaga() {
  try {
    const response: Specialty[] = yield call(specialtyApi.getSpecialties);
    yield put(getSpecialtiesSuccess(response));
  } catch (error) {
    yield put(getSpecialtiesFailure(error as Error));
  }
}

export function* watchGetSpecialties() {
  yield takeLatest(getSpecialtiesRequest.type, getSpecialtiesSaga);
}
